import { useEffect, useState } from "react"

import { isNonEmptyArray, distinctBy } from "web/services/helpers"

import LocationMap from "./LocationMap"
import TopicLocationCard from "./LocationCard/TopicLocationCard"

import { getMapBoxSafeValues } from "./common"

export default function TopicMap({
  subjectType,
  topic,
  topicRecords,
  onItemClick,
  onSelectionChanged,
  isLoading,
  showOrdinals,
}) {
  const [locationInFocus, setLocationInFocus] = useState()
  const hasLocationInFocus = !!locationInFocus

  const recordsWithLocations = topicRecords.filter((record) =>
    isNonEmptyArray(record.locations)
  )

  const locations = recordsWithLocations.map((record) => {
    const recordValues = getMapBoxSafeValues(record.values)
    return {
      ...record.locations[0],
      asset_id: record.asset_id,
      values: recordValues,
    }
  })

  const distinctLocations = distinctBy(locations, "id")

  const locationInFocusWithTopicRecords = { location: locationInFocus }

  if (hasLocationInFocus) {
    const recordsAtLocation = recordsWithLocations.filter((a) =>
      a.locations.some((l) => l.id === locationInFocus.id)
    )

    locationInFocusWithTopicRecords.records = recordsAtLocation
  }

  const primaryRecord =
    hasLocationInFocus && locationInFocusWithTopicRecords.records[0]

  const hasPrimaryRecord = !!primaryRecord

  // subject in focus may have been removed between
  // renders by change in filter conditions
  useEffect(() => {
    if (hasLocationInFocus && !hasPrimaryRecord) {
      setLocationInFocus(undefined)
    }
  }, [hasLocationInFocus, hasPrimaryRecord])

  const selected = topicRecords.filter((el) => el.selected)

  return (
    <LocationMap
      subjectType={subjectType}
      topic={topic}
      subjects={recordsWithLocations}
      primarySubject={primaryRecord}
      selected={selected}
      locations={distinctLocations}
      locationInFocus={locationInFocusWithTopicRecords}
      showSelectionSummary={false}
      onLocationClick={setLocationInFocus}
      onItemClick={onItemClick}
      onSelectionChanged={onSelectionChanged}
      detailCard={TopicLocationCard}
      isLoading={isLoading}
      showOrdinals={showOrdinals}
    />
  )
}
